// Angular
import { Component, OnInit, ElementRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// External
import { FormGroup, FormControl, Validators } from "@angular/forms";

import { Post } from "./../../models/post";
import { FormsService } from "./../../services/forms";

import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import { AngularFireAuth } from "angularfire2/auth";
import { OAuthService } from "./../../services/o-auth";
import { MatSnackBar } from "@angular/material";
import { isString } from "util";
import { ApiService } from "app/services/api";

@Component({
  templateUrl: "./user.detail.component.html",
})
export class UserDetailComponent implements OnInit {
  public post: any;
  public shared: Post;
  public form: FormGroup;
  public postData: any;
  public likeCount: number;
  public commentCount: number;
  public mentionCount: number;
  public mentioned: Array<any>;
  public commentList: Array<any>;
  public likeList: Array<{ author: string; authorImage: string; key: string }>;
  public shareLikes: Array<{
    author: string;
    authorImage: string;
    key: string;
  }>;
  public shareComments: Array<any>;
  public imageLoader: boolean = true;
  private postId: string;
  private author: string;
  public followerCount = 0;
  public postCount = 0;
  private attachmentExt: string;
  public text: string;
  public user: any;
  public userId: string;
  public profile: any;
  public list: Array<any> = [];
  public selectedItem = {};
  public isMember: any;
  public display1 = "none";
  public display2 = "none";
  public display3 = "none";
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    public snackBar: MatSnackBar,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase,
    private fireAuth: AngularFireAuth,
    public formsService: FormsService
  ) {
    this.form = new FormGroup({
      title: new FormControl("", Validators.required),
      body: new FormControl("", Validators.required),
      type: new FormControl(17),
    });
    this.user = this.oAuthService.getClub();
  }

  ngOnInit() {
    this.userId = this.route.snapshot.params["id"];
    let isMember = this.route.snapshot.params["ismember"];
    if (isMember == "true") {
      this.isMember = true;
    } else {
      this.isMember = false;
    }

    if (!this.userId) {
      return;
    }

    this.fireDatabase.object(`/users/${this.userId}`).subscribe(
      async (result) => {
        result["appversion"] = result["app-version"];

        this.profile = result;

        this.profile.uid = this.userId;

        this.profile.newEmail = this.profile.email;
        let prof = await this.apiService.object(
          "user-profiles/" + this.userId + "/" + this.user.cid
        );
        this.profile.role = parseInt(prof.role + "");
        this.profile.type = parseInt(prof.type + "");
        this.imageLoader = false;
      },
      (error) => {
        console.error(error);
        this.imageLoader = false;
      }
    );
    let count = 0;

    this.fireDatabase.list(`/users-posts/${this.userId}`).subscribe(
      (result: Array<any>) => {
        lodash.forEach(result, (item) => {
          count++;

          if (item.author) {
            ++this.postCount;
            this.fireDatabase
              .object(`/users/${item.author}`)
              .subscribe((user: any) => {
                item.author_name = user.username;
              });
            const date = new Date(item.date * 1000);

            const o =
              date.getFullYear() +
              "-" +
              ("0" + (date.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + date.getDate()).slice(-2);
            item.date = o;
            if (count === 1) {
              this.postDetail(item);
            }
            this.list.push(item);
          }
        });
      },
      (error) => {
        console.error(error);
      }
    );
    this.fireDatabase.object(`/user-followers/${this.userId}`).subscribe(
      (result) => {
        if (result.count) {
          this.followerCount = result.count;
        } else {
          this.followerCount = 0;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  remove(post, i) {
    if (confirm(`Are you sure to delete post?`)) {
      this.fireDatabase.database
        .ref(`/server-process/post-to-remove/${post.$key}`)
        .set(post.author)
        .then(() => {
          this.list.splice(i, 1);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  formatTime(timestamp) {
    const date = new Date(timestamp * 1000);

    // const time1 = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }
  public submit() {
    this.fireDatabase.database
      .ref(
        `/server-process/admin-notification/${this.userId}/${this.fireAuth.auth.currentUser.uid}`
      )
      .set(this.form.value)
      .then(() => {
        alert("Notification is Sent!");
      })
      .catch((error) => {
        console.error(error);
      });
  }
  postDetail(post: Post) {
    $("html, body").animate({ scrollTop: "1px" });
    this.commentList = [];
    this.likeList = [];
    this.shareLikes = [];
    this.shareComments = [];
    this.postData = post;
    if (post.photo) {
      this.attachmentExt = post.photo.url;
    }
    this.text = this.postData.text;
    this.fireDatabase.object(`/users/${post.author}`).subscribe((user: any) => {
      this.postData.authorName = user.username;
      this.postData.authorImage = user.avatar_thumb;
    });
    if (this.postData.mentioned) {
      this.mentioned = [];
      this.mentionCount = 0;
      lodash.forEach(this.postData.mentioned, (mention, key) => {
        this.mentionCount++;
        this.mentioned.push({
          user_name: mention.username,
          user_id: key,
        });
      });
    }
    if (this.postData.shared) {
      this.fireDatabase
        .object(
          `/users-posts/${this.postData.shared.uid}/${this.postData.shared.pid}`
        )
        .subscribe((shared) => {
          this.shared = shared;
          if (shared.$value) {
            this.postData.isShared = true;
            this.fireDatabase
              .object(`/users/${shared.author}`)
              .subscribe((user: any) => {
                this.postData.Sharedauthor = user.username;
                this.postData.SharedauthorImage = user.avatar_thumb;
              });
            this.fireDatabase
              .object(`/posts/${this.shared.$key}/likes`)
              .subscribe((likes) => {
                if (likes) {
                  lodash.forEach(likes, (like) => {
                    this.fireDatabase
                      .object(`/users/${like}`)
                      .subscribe((user: any) => {
                        like = user.username;
                        this.shareLikes.push({
                          author: user.username,
                          authorImage: user.avatar_thumb,
                          key: user.$key,
                        });
                      });
                  });
                }
              });
            this.fireDatabase
              .object(`/posts/${this.shared.$key}/comments`)
              .subscribe((comments) => {
                if (comments) {
                  lodash.forEach(comments, (comment) => {
                    if (comment) {
                      this.fireDatabase
                        .object(`/users/${comment.author}`)
                        .subscribe((user: any) => {
                          comment.author = user.username;
                          comment.authorImage = user.avatar_thumb;
                          comment.key = user.$key;
                          this.shareComments.push(comment);
                        });
                    }
                  });
                }
              });
          }
        });
    } else {
      this.postData.isShared = false;
    }
    this.fireDatabase.object(`/posts/${post.$key}/likes`).subscribe((likes) => {
      this.likeCount = 0;
      if (likes) {
        lodash.forEach(likes, (item, like) => {
          this.likeCount++;
          if (item) {
            this.fireDatabase
              .object(`/users/${like}`)
              .subscribe((user: any) => {
                like = user.username;
                this.likeList.push({
                  author: user.username,
                  authorImage: user.avatar_thumb,
                  key: user.$key,
                });
              });
          }
        });
      }
    });
    this.fireDatabase
      .object(`/posts/${post.$key}/comments`)
      .subscribe((comments) => {
        this.commentCount = 0;
        if (comments) {
          lodash.forEach(comments, (comment) => {
            this.commentCount++;
            if (comment) {
              this.fireDatabase
                .object(`/users/${comment.author}`)
                .subscribe((user: any) => {
                  comment.author = user.username;
                  comment.authorImage = user.avatar_thumb;
                  comment.key = user.$key;
                  this.commentList.push(comment);
                  // this.postData.date = moment().unix();
                  lodash.forEach(this.commentList, (item) => {
                    item.date = new Date(item.date * 1000);
                    var dd = item.date.getDate();
                    var mm = item.date.getMonth() + 1;
                    var yyyy = item.date.getFullYear();
                    item.date = dd + "/" + mm + "/" + yyyy;
                  });
                });
            }
          });
        }
      });
  }
  onChangeEmail() {
    this.profile.newEmail = this.profile.email;
    this.display1 = "block";
  }
  submitEmail() {
    this.apiService.set(
      "server-process/change-user-email/" + this.profile.uid+"/"+this.profile.uid,
      this.profile.newEmail
    );
    setTimeout(() => {
      this.apiService
        .object("server-process/change-user-email/" + this.profile.uid)
        .then((res) => {
          if (res.isError) {
            this.profile.newEmail = this.profile.email;
            // this.snackBar.open("Email already exist!!", "OK!", {
            //   duration: 3000,
            // });
            alert("Email already exist!!")
          } else {
            this.profile.email = this.profile.newEmail;
            this.snackBar.open("Email changed successfully!!", "OK!", {
              duration: 3000,
            });
          }
          this.fireDatabase
            .object("server-process/change-user-email/" + this.profile.uid)
            .set(null);
        });
    }, 1100);
  }

  close() {
    this.profile.newEmail = this.profile.email;
    this.display3 = "none";
  }
  isWebsiteLinkChange() {
    this.apiService.set(
      `/users/${this.userId}/isWebsiteLink`,
      this.profile.isWebsiteLink
    );
    let link = "https://golfhubber.com/#/pro/" + this.profile.username;
    this.apiService.set(`/users/${this.userId}/websiteLink`, link);
  }
  onBioChange() {
    this.display2 = "block";
  }
  onWidgetChange() {
    this.display3 = "block";
  }
  updateBio() {
    this.apiService.set(`/users/${this.userId}/bio`, this.profile.bio);
  }
  updateWidget() {
    this.apiService.set(`/users/${this.userId}/widget`, this.profile.widget);
  }
  copyToclipboard(websiteLink: ElementRef) {
    document.execCommand("copy");
  }

  copyText(val: string) {
    let selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }
}
